/**
 * Tap-versus-drag on the score.
 *
 * Phaser reports pointer positions in canvas pixels, and the score canvas is
 * drawn at the device pixel ratio. A finger moves a little between touching
 * down and lifting, so the allowance has to be measured in CSS pixels: a fixed
 * canvas-pixel allowance shrinks to a third on a 3x phone, and an ordinary tap
 * there is read as a drag and ignored.
 */
export const SCORE_TAP_SLOP_CSS_PX = 10;

export function isScoreTap(
  dragDistanceX: number,
  dragDistanceY: number,
  devicePixelRatio: number,
): boolean {
  if (![dragDistanceX, dragDistanceY, devicePixelRatio].every(Number.isFinite)) return false;
  const pixelRatio = devicePixelRatio > 0 ? devicePixelRatio : 1;
  const slopInCanvasPixels = SCORE_TAP_SLOP_CSS_PX * pixelRatio;
  return (
    Math.abs(dragDistanceX) < slopInCanvasPixels && Math.abs(dragDistanceY) < slopInCanvasPixels
  );
}
